import App from 'App';
import Messages from 'components/Messages';
import i18n from 'i18n';
import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { store } from 'store';
import './styles.css';

const render = (AppComponent: React.FC<Record<string, unknown>>) => {
  ReactDOM.render(
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <Messages />
        <AppComponent />
      </Provider>
    </I18nextProvider>,

    document.getElementById('root')
  );
};

render(App);
